module.exports = __webpack_public_path__ + "img/france-cardiovascular-diseases-male.56323680.png";